module.exports = __webpack_public_path__ + "media/images/gear-2e62712a7fcc2dd98cb3f237d58fde3939a283c3c033372f8a6852cbaaaa89ee.svg";